module.exports = __webpack_public_path__ + "assets/eccd637819d1bae406e8d03f4322b401.mp3";